<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <section class="text-gray-600 body-font">
                                    <div class="container px-5 mx-auto">
                                        <div class="text-center mb-10">
                                        <h1 class="sm:text-3xl text-2xl font-medium text-center title-font text-gray-900 mb-4">{{ $page.props.jenis_pengadaan.nama_jenis_pengadaan }}</h1>
                                        <p class="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">{{ $page.props.jenis_pengadaan.keterangan }}</p>
                                        </div>
                                        <div class="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
                                            <div class="p-2 w-full" v-for="tahapan_pengadaan in $page.props.tahapan_pengadaan" :key="tahapan_pengadaan.urutan_ke">
                                                <div class="bg-gray-100 rounded flex p-4 h-full items-center">
                                                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" class="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4" viewBox="0 0 24 24">
                                                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                                                    <path d="M22 4L12 14.01l-3-3"></path>
                                                </svg>
                                                <span class="title-font font-medium">{{ tahapan_pengadaan.nama_tahapan }}</span>
                                                </div>
                                            </div>
                                            <div class="p-2 mt-5 w-full" >
                                                <JetLabel
                                                    class="w-full"
                                                    for="created_at"
                                                    :value='"<b>Created At :</b> " + createdAt + ""'
                                                />
                                                <JetLabel
                                                    class="w-full mt-2"
                                                    for="created_by"
                                                    :value='"<b>Created By :</b> " + $page.props.jenis_pengadaan.created_by + ""'
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>
<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import JetLabel from "@/Jetstream/Label";
import { Pesan } from "@/constants";
import moment from 'moment';

export default defineComponent({
    components: {
        AppLayout,
        BreadCrumb,
        JetLabel,
    },
    data() {
        return {

        };
    },
    computed: {
        createdAt: function () {
            moment.locale("id");
            return moment(this.$page.props.jenis_pengadaan.created_at).format('Do MMMM YYYY, h:mm:ss a');
        }
    },
    created(){
    },
    methods: {

    },
});
</script>
